'use client'

import { createTheme } from '@mui/material/styles'

import { colors } from './colors'
import { typography } from './typography'

declare module '@mui/material/styles/createPalette' {
  interface PaletteOptions {
    white?: ColorPartial
    black?: ColorPartial
  }
}

export const theme = createTheme({
  // expose CSS Variables, so we can use them in (S)CSS Modules
  cssVariables: true,

  spacing: 4,

  palette: {
    primary: {
      ...colors.blue,
      main: colors.blue[500],
      light: colors.blue[300],
      dark: colors.blue[600],
      contrastText: '#fff',
    },
    secondary: {
      ...colors.orange,
      main: colors.orange[500],
      light: colors.orange[300],
      dark: colors.orange[600],
      contrastText: '#fff',
    },
    success: {
      ...colors.green,
      main: colors.green[500],
      light: colors.green[300],
      dark: colors.green[600],
      contrastText: '#fff',
    },
    warning: {
      ...colors.yellow,
      main: colors.yellow[500],
      light: colors.yellow[300],
      dark: colors.yellow[600],
      contrastText: '#000',
    },
    error: {
      ...colors.red,
      main: colors.red[500],
      light: colors.red[300],
      dark: colors.red[600],
      contrastText: '#fff',
    },
    info: {
      ...colors.grey,
      main: colors.grey[500],
      light: colors.grey[300],
      dark: colors.grey[600],
      contrastText: '#000',
    },
    text: {
      primary: '#27374c',
      secondary: 'rgba(0,0,0,.62)',
      disabled: 'rgba(0,0,0,.38)',
    },
    grey: {
      ...colors.grey,
    },
    white: {
      800: '#fff',
      600: 'rgba(255,255,255,.62)',
      400: 'rgba(255,255,255,.38)',
    },
    black: {
      800: 'rgba(0,0,0,.85)',
      600: 'rgba(0,0,0,.62)',
      400: 'rgba(0,0,0,.38)',
    },
  },
  typography,

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 400,
        },
      },
    },
  },
})
